import { render, staticRenderFns } from "./SpeechControl.vue?vue&type=template&id=07d5e9fe&scoped=true&"
import script from "./SpeechControl.vue?vue&type=script&lang=js&"
export * from "./SpeechControl.vue?vue&type=script&lang=js&"
import style0 from "./SpeechControl.vue?vue&type=style&index=0&id=07d5e9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5e9fe",
  null
  
)

export default component.exports